import { xcss } from '@atlaskit/primitives';

export const boxStyles = xcss({
  borderStyle: 'solid',
  borderRadius: 'border.radius.200',
  borderWidth: 'border.width',
  borderColor: 'color.border.disabled',
  marginBottom: 'space.200',
  width: '100%',
});
